<script setup lang="ts">
import type { BadgeColor } from '#ui/types';

type Props = {
    row: Record<string, any> & { slug: 'asinx_blue_mc' | 'hipay_blue_mc' | 'asinx_green_visa' },
    slugTypeId: string | number | undefined;
}

const { row, slugTypeId } = defineProps<Props>()
const suffix = (prefix: string) => slugTypeId === undefined || slugTypeId === null ? '' : ` (${prefix}_${slugTypeId})`
const slugType = computed(() => ({
	asinx_blue_mc: {
		label: `MasterCard${suffix('AX')}`,
		color: 'blue' as BadgeColor
	},
	hipay_blue_mc: {
		label: `MasterCard${suffix('HP')}`,
		color: 'blue' as BadgeColor
	},
	asinx_green_visa: {
		label: `Visa${suffix('AX')}`,
		color: 'green' as BadgeColor
	}
}))

const badgeColor = computed(() => {
	return slugType.value[row.slug]?.color || 'gray';
})

const badgeLabel = computed(() => {
	return slugType.value[row.slug]?.label || '-'
})
</script>

<template>
	<UBadge
		:color="badgeColor"
		:label="badgeLabel"
		variant="solid"
	/>
</template>
